export enum AuthProviders {
    GOOGLE = 'google',
    FACEBOOK = 'facebook',
    APPLE = 'apple',
    LINKEDIN = 'linkedin',
    TWITTER = 'twitter',
    GITHUB = 'github',
    MICROSOFT = 'microsoft',
    AMAZON = 'amazon',
    INSTAGRAM = 'instagram',
    DISCORD = 'discord',
}